var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAddOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.85 7.94999C18.85 6.37517 17.5748 5.09999 16 5.09999C14.4252 5.09999 13.15 6.37517 13.15 7.94999C13.15 9.52481 14.4252 10.8 16 10.8C17.5748 10.8 18.85 9.52481 18.85 7.94999ZM20.65 7.94999C20.65 10.5189 18.5689 12.6 16 12.6C13.4311 12.6 11.35 10.5189 11.35 7.94999C11.35 5.38106 13.4311 3.29999 16 3.29999C18.5689 3.29999 20.65 5.38106 20.65 7.94999ZM9.9 18.4286C9.9 19.1974 9.80923 19.1 10.2353 19.1H21.7647C22.1908 19.1 22.1 19.1974 22.1 18.4286C22.1 16.536 19.3218 15.4 16 15.4C12.6782 15.4 9.9 16.536 9.9 18.4286ZM16 13.6C20.2272 13.6 23.9 15.1018 23.9 18.4286C23.9 20.1642 23.2145 20.9 21.7647 20.9H10.2353C8.78554 20.9 8.1 20.1642 8.1 18.4286C8.1 15.1018 11.7728 13.6 16 13.6ZM5 6.49999C5.49706 6.49999 5.9 6.90293 5.9 7.39999L5.899 10.1L8.6 10.1C9.09706 10.1 9.5 10.5029 9.5 11C9.5 11.497 9.09706 11.9 8.6 11.9H5.899L5.9 14.6C5.9 15.097 5.49706 15.5 5 15.5C4.50294 15.5 4.1 15.097 4.1 14.6L4.099 11.9H1.4C0.902944 11.9 0.5 11.497 0.5 11C0.5 10.5029 0.902944 10.1 1.4 10.1L4.099 10.1L4.1 7.39999C4.1 6.90293 4.50294 6.49999 5 6.49999Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAddOutline);
export default __webpack_public_path__ + "static/media/user_add_outline.f89c44a91fa1986e5de40fe86dd138f9.svg";
export { ForwardRef as ReactComponent };